import { ConnectedDeviceDetailsPage } from "fleet/controller/device/connected-detail";
import { ConnectedDeviceEvents } from "fleet/controller/device/connected-device-events";
import { ConnectedDeviceInternalsPage } from "fleet/controller/device/connected-device-internals";
import { ConnectedDeviceLogsPage } from "fleet/controller/device/connected-device-logs";
import { ConnectedDeviceOverview } from "fleet/controller/device/connected-device-overview";
import { DeviceViewPage } from "fleet/view/device/view";
import PropTypes from "prop-types";
import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";

function DeviceView(props) {
  const {
    activeTab,
    clearPlayerCache,
    clearWebcamSnapshotCache,
    device,
    deviceId,
    deviceStatus,
    featureFlags,
    isThirdParty,
    loadDeviceStats,
    restartDevice,
    stats,
    storesLoaded,
    unloadDeviceStats,
    user,
  } = props;

  if (storesLoaded && !device) {
    return <Redirect to="/404" />;
  }

  return (
    <DeviceViewPage
      activeTab={activeTab}
      clearPlayerCache={clearPlayerCache}
      clearWebcamSnapshotCache={clearWebcamSnapshotCache}
      device={device}
      deviceId={deviceId}
      deviceStatus={deviceStatus}
      featureFlags={featureFlags}
      isThirdParty={isThirdParty}
      loadDeviceStats={loadDeviceStats}
      restartDevice={restartDevice}
      storesLoaded={storesLoaded}
      unloadDeviceStats={unloadDeviceStats}
      user={user}
    >
      <Switch>
        <Route
          path="/devices/:deviceId/overview"
          render={() => {
            return (
              <ConnectedDeviceOverview
                device={device}
                deviceId={deviceId}
                deviceStatus={deviceStatus}
                isThirdParty={isThirdParty}
                stats={stats}
                storesLoaded={storesLoaded}
              />
            );
          }}
        />
        {!isThirdParty && (
          <Route
            path="/devices/:deviceId/details"
            render={() => {
              return (
                <ConnectedDeviceDetailsPage
                  device={device}
                  deviceId={deviceId}
                  deviceStatus={deviceStatus}
                  storesLoaded={storesLoaded}
                />
              );
            }}
          />
        )}
        <Route
          path="/devices/:deviceId/internals"
          render={() => {
            return <ConnectedDeviceInternalsPage device={device} />;
          }}
        />
        <Route
          path="/devices/:deviceId/logs"
          render={() => {
            return (
              <ConnectedDeviceLogsPage
                device={device}
                storesLoaded={storesLoaded}
              />
            );
          }}
        />
        <Route
          path="/devices/:deviceId/events"
          render={() => {
            return (
              <ConnectedDeviceEvents
                device={device}
                deviceId={deviceId}
                storesLoaded={storesLoaded}
              />
            );
          }}
        />
        <Redirect
          from="/devices/:deviceId"
          to={`/devices/${deviceId}/overview`}
        />
      </Switch>
    </DeviceViewPage>
  );
}

DeviceView.propTypes = {
  activeTab: PropTypes.string,
  clearPlayerCache: PropTypes.func.isRequired,
  device: PropTypes.object,
  deviceId: PropTypes.string.isRequired,
  deviceStatus: PropTypes.object.isRequired,
  isThirdParty: PropTypes.bool.isRequired,
  loadDeviceStats: PropTypes.func.isRequired,
  restartDevice: PropTypes.func.isRequired,
  stats: PropTypes.object,
  storesLoaded: PropTypes.bool.isRequired,
  unloadDeviceStats: PropTypes.func.isRequired,
  user: PropTypes.object,
};

DeviceView.defaultProps = {
  activeTab: "",
};

export { DeviceView };
